import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme: Theme) => ({
  successMessage: {
    minWidth: 344
  }
}));

export default styles;